import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { AssignmentInformationComponent } from './assignment-information/assignment-information.component';

@Component({
  selector: 'tab-general-details',
  standalone: true,
  templateUrl: './general-details.component.html',
  styleUrls: ['./general-details.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    TabsInnerWrapComponent,
    AssignmentInformationComponent,
  ],
})

export class GeneralDetailsComponent {}
